import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Envasado/generarExcel`, method: 'POST', body: list, token: token})
}